import { resetQueryClient } from '@/queryClient.js'
import { getActivePinia } from 'pinia'

export function resetAllStores() {
  resetPiniaStores()
  resetQueryClient()
}

function resetPiniaStores() {
  getActivePinia()._s.forEach(store => {
    try {
      store.$reset()
    } catch (e) {
      console.warn(`[resetAllStores] Could not reset store ${store.$id}`, e)
    }
  })
}
